<template>
  <div>
    <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
      <input
        ref="textLink"
        type="text"
        :value="'https://app.duotalk.io/invitation/' + params.value"
        class="hidden"
      />
      <feather-icon
        v-if="params.value"
        icon="Link2Icon"
        class="text-primary"
        svgClasses="h-5 w-5 hover:text-success cursor-pointer"
        @click="copyLink"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererLink",
  computed: {},
  methods: {
    copyLink() {
      var copyText = this.$refs.textLink;

      copyText.select();
      copyText.setSelectionRange(0, 99999);

      navigator.clipboard.writeText(copyText.value);

      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("CopiedToClipboard"),
        color: "success",
        iconPack: "feather",
        position: "top-right",
        icon: "icon-check-circle",
        time: 4000,
      });
    },
  },
};
</script>
